import { Component, h } from '@stencil/core';

@Component({
  tag: 'spw-table-body',
  styleUrl: 'spw-table-body.scss',
  shadow: true,
})
export class SpwTableBody {
  render() {
    return (
      <tbody part="tbody">
        <slot />
      </tbody>
    );
  }
}
